module.exports = "/_next/static/images/afb590adaca4256a8baba7a9ccdc8ec1-device-frame@3x.png";